// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"bc120a15","164":"0dd51563","268":"4a31670a","453":"1c29ee80","777":"006d141a","831":"bf6ec9fb"}[chunkId] + ".chunk.js";
};